import React from "react";
import { ArrowRight } from "lucide-react";
import CTAButton from "../ui/CTAButton";

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-white">
      {/* Background Pattern */}
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-psa-green-50 rounded-full opacity-70"></div>
        <div className="absolute top-1/2 -left-24 w-64 h-64 bg-psa-gold-50 rounded-full opacity-70"></div>
      </div>

      <div className="container mx-auto px-4 pt-20 pb-24 md:pt-28 md:pb-32 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="lg:pr-10 max-w-xl animate-slide-up">
            <h1 className="text-4xl md:text-3xl lg:text-3xl font-bold text-gray-900 leading-tight mb-6 font-display">
              Expert Tax, VAT, RJSC, BIDA & Business Consultancy
            </h1>
            <p className="text-xl md:text-xl text-gray-600 mb-8 leading-relaxed">
              Professional Service Associates provides comprehensive Taxation,
              VAT, RJSC, BIDA and business consulting services to help you
              navigate complex financial regulations.
            </p>
            <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0">
              <CTAButton to="/contact">Get in Touch</CTAButton>
              <CTAButton to="/services" primary={false}>
                <span className="flex items-center">
                  Our Services
                  <ArrowRight size={18} className="ml-2" />
                </span>
              </CTAButton>
            </div>
          </div>

          <div className="relative lg:pl-10 animate-fade-in">
            <div className="bg-white rounded-xl shadow-xl overflow-hidden relative z-10">
              <img
                src="https://images.pexels.com/photos/3760067/pexels-photo-3760067.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                alt="Professional tax consultants in a meeting"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-2/3 h-1/2 bg-psa-green-600 rounded-lg -z-0"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
